import * as RasaDragCell from '../../../components/drag-cell'
import * as Constants from '../constants'

export class DragCell extends RasaDragCell.DragCell {
  constructor(props: any) {
    super(props, Constants.FETCH_LEAD_POSTS)
  }
}



// WEBPACK FOOTER //
// ./src/pages/content-calendar/render/drag_cell.tsx